export default __webpack_public_path__ + "static/media/budget.cf15d469.png";